<template>
<div class="chapter">
<div class="inner_page">
<a id="page_6"></a>
<p class="fm"><em class="italic">I will show you a philtre without potions, without herbs, without any witch’s incantation: if you wish to be loved, love.</em></p>
<p class="fmr">Seneca</p>
<div class="img_container">
<img alt="image" src="images/f0006-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm01.vue?d925b174